















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component<Footer>({})
export default class Footer extends Vue {}
